import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const container = document.getElementById("root")!;

// If the page was prerendered (has real children, not just the initial loader
// that we strip during prerender), hydrate instead of re-rendering. This keeps
// SSR-friendly HTML visible to crawlers while preserving full interactivity.
const isPrerendered = container.hasAttribute("data-prerendered");

if (isPrerendered) {
  hydrateRoot(container, <App />);
} else {
  createRoot(container).render(<App />);
}
